import { requestNotificationPermission } from '@/core/firebase'
import { storageService } from '@/core/services/storage'
import { useActionState, useCallback, useTransition } from 'react'
import { subscribePushNotificationAction } from '../actions/subscribe-push-notification.action'
import { STORAGE_KEYS } from '@/core/constants/storage-keys'

export const useInitNotifications = () => {
  const [, subscribePushNotification] = useActionState(
    subscribePushNotificationAction,
    null,
  )
  const [, startTransition] = useTransition()
  const initNotifications = useCallback(() => {
    requestNotificationPermission().then(res => {
      if (!res) return
      storageService.setItem(STORAGE_KEYS.fcmToken, res.fcmToken)
      startTransition(() => subscribePushNotification(res.fcmToken))
    })
  }, [])

  return initNotifications
}
